import { createSelector } from 'reselect'

import { getFilterForReport } from '../helpers/getFilterForReport'

import { selectComposedReportState } from './selectComposedReportState'

export const selectFilterForReport = createSelector(
  [selectComposedReportState],
  ({
    geo,
    partnersInScope,
    scopeValue,
    pbms,
    products,
    managers,
    specializations,
    acknowledged,
    amplifyMembership,
    fYear,
    partnersType,
    isAcknowledged,
  }) => {
    return getFilterForReport({
      geo,
      partnersInScope,
      scopeValue,
      pbms,
      products,
      managers,
      specializations,
      acknowledged,
      amplifyMembership,
      fYear,
      partnersType,
      isAcknowledged,
    })
  }
)
